var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('Nuxt')],1),_vm._v(" "),_c('f-footer-register')],1)}
var staticRenderFns = []

export { render, staticRenderFns }